import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category6-lang',
  templateUrl: './textile-model-category6-lang.component.html',
  styleUrls: ['./textile-model-category6-lang.component.css']
})
export class TextileModelCategory6LangComponent implements OnInit {
    textileModelCategory6Keyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.textileModelCategory6Keyno = this.stateService.getStateParams()['textilemodelcategory6_keyno'];
    }

    private async loadLanguages() {
        if (!!this.textileModelCategory6Keyno) {
            this.inputListLanguages = await this.datatask.Post(2693, { textilemodelcategory6_keyno: this.textileModelCategory6Keyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2694, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    textilemodelcategory6_keyno: string;
    textilemodelcategory6lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory6Lang', {
//        templateUrl: 'views/components/views/textileModelCategory6Lang/textileModelCategory6Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory6LangService', function ($stateParams, stateService, textileModelCategory6LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory6Keyno = $stateParams.textilemodelcategory6_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await textileModelCategory6LangService.listTextileModelCategory6Languages({ textilemodelcategory6_keyno: textileModelCategory6Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory6LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
